import React from "react";

function SvgIcMapPoi131(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 25v-7H9v-7h7v7h7c0 3.86-3.14 7-7 7zm9-16v9a9 9 0 01-9 9 9 9 0 01-9-9V9h18zm1-4a2 2 0 01-2 2H8a2 2 0 01-2-2z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi131;
